<template>
  <l-layout :layout="['xs12']">
    <l-data-table
      :get-data-func="getZStudent"
      :headers="headers"
      :must-sort="false"
      @click:row="goDetails($event.item)"
      clickable
      item-key="code"
      search-text="搜索姓名"
      title-text="终教生列表"
      :filter-items="filterItems"
    ></l-data-table>
  </l-layout>
</template>

<script>
  export default {
    name: 'ZjsList',
    data () {
      return {
        headers: [
          {text: '姓名', value: 'name', align: 'left', placeholder: 'N/A', sortable: false},
          {text: '学籍编号', value: 'code', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '手机', value: 'phone', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '所在单位', value: 'department', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '状态', value: 'status', align: 'right', placeholder: 'N/A', sortable: false},
          {text: '更新时间', value: 'updateTime', align: 'right', placeholder: 'N/A', sortable: false},
        ],
        filterItems:[
          {
            prependIcon: '$vuetify.icons.person',
            key: 'loginId',
            value: '',
            label: '学籍编号',
            type: 'input',
            layout: ['xs12', 'sm4'],
          },
        ],
      }
    },
    methods: {
      async getZStudent ({pagination, search,filterItems}) {
        return this.$store.dispatch('mva/getZStudent', {
          pagination,
          search: {name: {keyword: search}},
          filterItems
        })
      },
      goDetails (item, force = false) {
        let selectionString = document.getSelection().toString()
        if (!selectionString || force) {
          this.$router.push({
            name: 'ZjsDetails',
            params: {name: item.name},
            query: {code: item.code}
          })
        }
      }
    }
  }
</script>

<style scoped>

</style>
